import { FC, useState } from "react";
import CardCustom from "../../components/card";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import useGetWithdrawal from "../../service/useWithdrawl/getWithdrawl";
import { TableCustomProps } from "../../components/table/table";
import './withdrawal.css'
import ButtonUI from "../../components/button/buttons";
import HelpIcon from '@mui/icons-material/Help';
import { formatToMexicanPesos } from "../../utils/format";
import { WithdrawInfoModal } from "./withdrawalModal/WithdrawInfoModal";

interface IWithdrawlsProps {}

const Withdrawals: FC<IWithdrawlsProps> = (props) => {
  const storedToken = sessionStorage.getItem("userData");

  const [tabMovements, setTabMovements] = useState("awaiting_withdrawal");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [email, setEmail] = useState<string>("");
  const [page, setPage] = useState(1);
  const [searchClicked, setSearchClicked] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { withdrawal, loading } = useGetWithdrawal(
    storedToken,
    page,
    rowsPerPage,
    "awaiting_withdrawal"
  );

  const handleChange = (event: any, newValue: string) => {
    setTabMovements(newValue);
  };

  const onChangeEmail = (e: any) => {
    setEmail(e.target.value);
  };
  function a11yProps(index: string) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  const [selectedWithdraw, setSelectedWithdraw] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = (withdraw: any) => {
    setSelectedWithdraw(withdraw);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedWithdraw(null);
  };

  const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {
    const translations: { [key: string]: string } = {
      approved_withdrawal: "Aprobado",
      DECLINED: "Rechazado",
      PENDING: "Pendiente",
      FAILED: "Rechazado",
      awaiting_withdrawal: "Pendiente",
    };

    const translateStatus = (status: string): string => {
      return translations[status] || status;
    };

    return transactions.map((transaction) => ({
      profileId	: transaction.profileId,
      id: transaction._id,
      activity: transaction.status_description,
      email: transaction.email,
      amount: formatToMexicanPesos(transaction.amount),
      amount_without:
        "$ " + (transaction.amount - transaction.amount_with_comision),
      comision: "$ " + transaction.amount_with_comision,
      date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      status: (
        <div className={`status ${transaction.status.toLowerCase()}`}>
          {translateStatus(transaction.status)}
        </div>
      ),

      info:         <div>
          <ButtonUI
            icon={<HelpIcon />}
            onClick={() => handleOpenModal(transaction)}
            variant="text"
          />
        </div>,
    }));
  };

  const dataTable: any = {
    columns: [
            { id: "email", label: "Usuario" },
      //{ id: "profileId", label: "IdUsuario" },
      { id: "id", label: "Orden de dispersión" },
      { id: "amount", label: "Monto Solicitado" },
      { id: "date", label: "Fecha" },
      { id: "status", label: "Estatus" },
      { id: "info", label: "Info" },
    ],
    rows: transformDataToTable(withdrawal?.data?.data || []),
  };


  const pagination = withdrawal?.data?.pagination || {
    page: 1,
    pageSize: 10,
    countData: 0,
    totalPages: 0,
  };

  return (
    <div>
      <CardCustom classCustom="activity_card">
        <h2>Dispersiones</h2>
        <p>
          Esta sección te permite gestionar todas los dispersiones de los
          usuarios registrados en nuestra plataforma.
        </p>

        {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabMovements}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="EN ESPERA"
              {...a11yProps("APPROVED")}
              value="APPROVED"
            />
            <Tab
              label="APROBADAS"
              {...a11yProps("charge_pending")}
              value="charge_pending"
            />
            <Tab
              label="RECHAZADO"
              {...a11yProps("DECLINED")}
              value="DEfCLINED"
            />
          </Tabs>
        </Box> */}
        <TableMaterial
          id="withdrawal-reportes"
          valueInput={email}
          onClickSearch={handleSearchClick}
          onChangeInput={onChangeEmail}
          isDate={true}
          setEndDate={setEndStartDate}
          setStartDate={setStartDate}
          startDate={startDate}
          endDate={endStarDate}
          totalRows={pagination.countData} // total de registros          
          setPage={setPage}
          page={page} // MUI usa base 0          setRowsPerPage={setRowsPerPage}
          rowsPerPage={parseInt(pagination.pageSize)}
          report={true}
          columns={dataTable?.columns}
          rows={dataTable?.rows}
          loading={loading}
        />
      </CardCustom>
      <WithdrawInfoModal
        open={openModal}
        onClose={handleCloseModal}
        data={selectedWithdraw}
      />
    </div>
  );
};

export default Withdrawals;
